export default class PdfCell {
    /**
     * Constructs PDF Cell object
     * @param {Int} x 
     * @param {Int} y 
     * @param {Int} width 
     * @param {Int} height 
     * @param {String} text 
     * @param {Int} fontSize 
     * @param {Int} border 
     * @param {String} align
     */
    constructor(x, y, width, height, text, fontSize, border, align, fontType) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.text = text;
        this.font_size = fontSize;
        this.border = border;
        this.align = align;
        this.font_type = fontType ? fontType : "";
    }
}